import sdl from '@jds/react-generated-sdl/JDSTooltip';
import type { JDSTooltipProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, TooltipProps } from '../logic';

const Component = (props: TooltipProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    position = 'right',
    open = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { position, open, ...rest },
    'JDSTooltip',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Tooltip = withLogic(Component) as React.FC<TooltipProps> & {
  slotName?: string;
};

Tooltip.displayName = 'Tooltip';
Tooltip.slotName = 'jds_tooltip';

export { Tooltip, type JDSTooltipProps };
